import { createSlice } from "@reduxjs/toolkit";
import { 
  getBookFlow, 
  createBookFlow, 
  updateBookFlow, 
  deleteBookFlow,
  clearLocalActiveBookFlow
} from "./actions"; 

export const initialState = {
  bookFlow: { 
    id: '', 
    completion_emails: [],
    failure_emails: [], 
    updated_at: '' 
  },
  loading: false
};

const slice = createSlice({
  name: 'bookFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getBookFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBookFlow.fulfilled, (state, action) => {
        const { book_flow } = action.payload;
        const bookFlow = { ...state.bookFlow, ...book_flow };

        state.loading = false;
        state.bookFlow = bookFlow;
      })
      .addCase(getBookFlow.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createBookFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createBookFlow.fulfilled, (state, action) => {
        const { book_flow } = action.payload;

        state.loading = false;
        state.bookFlow = book_flow;       
      })
      .addCase(createBookFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateBookFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateBookFlow.fulfilled, (state, action) => {
        const { status, book_flow } = action.payload;
        const updatedBookFlow = { ...state.bookFlow, ...book_flow };

        state.loading = false;
        if (status === 204) state.bookFlow = updatedBookFlow;       
      })
      .addCase(updateBookFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteBookFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteBookFlow.fulfilled, (state, action) => {
        const { status } = action.payload;

        state.loading = false;
        if (status === 204) state.bookFlow = initialState.bookFlow;       
      })
      .addCase(deleteBookFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveBookFlow, state => {
        state.bookFlow = initialState.bookFlow;
      })
  }
})

export default slice.reducer;